"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.styles_tw = void 0;
/*
  If it happens that productTableColumns changes length, you must come here and change the amount of fractions.
*/
exports.styles_tw = {
    table: "grid grid-cols-[1fr_1fr_1fr_1fr_1fr_1fr_1fr_20px]",
};
